module.exports = __webpack_public_path__ + "img/award_gold.4272fa70.svg";